import clsx from 'clsx'
import PropTypes from 'prop-types'
import { useRef, useState } from 'react'

import ErrorText from '../ErrorText'

import styles from './style.module.scss'

export const Input = ({
  value,
  onChangeText,
  error,
  errorMessage,
  enableSuggestion,
  suggestionOptions,
  onClickSuggestion,
  onChangeFocus,
  loading,
  loadingText = 'Searching',
  onScrollToBottom,
  containerClassName,
  containerStyle,
  type,
  ...rest
}) => {
  const [isFocus, setFocus] = useState(false)

  const onFocus = () => {
    setFocus(true)
    onChangeFocus && onChangeFocus(true)
  }

  const onBlur = () => {
    setTimeout(() => {
      setFocus(false)
      onChangeFocus && onChangeFocus(false)
    }, 150)
  }

  const handleScroll = e => {
    if (!onScrollToBottom) return

    const el = e.currentTarget

    if (!el) return

    if (el.scrollTop + el.offsetHeight >= el.scrollHeight) {
      onScrollToBottom()
    }
  }

  return (
    <div className={clsx(styles.container, containerClassName)} style={containerStyle}>
      <input
        className={error ? styles.form_input_error : styles.form_input}
        onChange={e => {
          const value = e.target.value

          if (type !== 'tel') {
            onChangeText(value)
            return
          }

          // Tel validation
          if (!value.length || !isNaN(value[value.length - 1])) {
            onChangeText(value.trim())
          }
        }}
        value={value}
        onFocus={onFocus}
        onBlur={onBlur}
        {...rest}
      />

      {enableSuggestion && suggestionOptions && isFocus && (
        <div className={styles.form_suggestion} onScroll={handleScroll}>
          {suggestionOptions.map((option, i) => (
            <div
              key={i}
              className={styles.form_suggestion_row}
              onClick={() => {
                onClickSuggestion({
                  index: i,
                  label: option.label,
                  value: option.value,
                })
              }}>
              {option.label}
            </div>
          ))}

          {loading && <div className={styles.form_loading_row}>{loadingText}</div>}
        </div>
      )}

      {error &&
        errorMessage &&
        (Array.isArray(errorMessage) ? (
          errorMessage.map(e => <ErrorText key={e} errorMessage={e} />)
        ) : (
          <ErrorText errorMessage={errorMessage} />
        ))}
    </div>
  )
}

Input.propTypes = {
  label: PropTypes.string.isRequired,
  required: PropTypes.boolean,
  value: PropTypes.string,
  onChangeText: PropTypes.func,
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  containerStyle: PropTypes.object,
  enableSuggestion: PropTypes.boolean,
  suggestionOptions: PropTypes.array,
}

export default Input
